export default __webpack_public_path__ + "static/media/mobile.30ce9601.svg";